import type { SchemaElement } from "../../../api/restaurantSchema";

/** Броят маси по места — чиповете-филтри над мрежата. */
export const seatGroups = (tables: SchemaElement[]) => {
  const counts = new Map<number, number>();
  tables.forEach((table) => counts.set(table.seats ?? 0, (counts.get(table.seats ?? 0) ?? 0) + 1));
  return [...counts.entries()].sort(([left], [right]) => left - right);
};
